import {useMutation, UseMutationOptions, UseMutationResult} from '@tanstack/react-query';

import {fetchCompetitorsTable, fetchExportCompetitors, fetchSummary} from './competitors-page-api';
import {
    CompetitorsSummaryStatsRequestType,
    CompetitorsTableRequestOptionsType,
    CompetitorsTableResponseType,
    ExportExcelType,
    SummaryType,
} from './competitors-page-type';

export function useCompetitorsTable(): UseMutationResult<
    CompetitorsTableResponseType,
    unknown,
    CompetitorsTableRequestOptionsType
> {
    return useMutation(['fetch-competitors-table'], (options) => {
        return fetchCompetitorsTable(options);
    });
}

export function useSummaryStats(): UseMutationResult<SummaryType, unknown, CompetitorsSummaryStatsRequestType> {
    return useMutation(['fetch-summary-stats'], (options) => {
        return fetchSummary(options);
    });
}

export function useExportCompetitors(
    options?: UseMutationOptions<unknown, unknown, ExportExcelType>
): UseMutationResult<unknown, unknown, ExportExcelType> {
    return useMutation(
        ['export-competitors'],
        (parameters: ExportExcelType) => fetchExportCompetitors(parameters),
        options
    );
}
